import FieldWrapper from "./partials/FieldWrapper";
import ColorPicker from "../ColorPicker";

export default FieldWrapper(ColorPicker);
